import React, { useState } from "react";
import PageHeader from "./PageHeader.jsx";
import WelcomeModal from "./WelcomeModal.jsx";

export default function LoginPage({ onLogin, onGoToSignup }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    setError('');
    
    if (!username.trim() || !password) {
      setError('Please enter both username and password');
      return;
    }

    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
        credentials: 'include',
      });
      
      if (!res.ok) {
        const errorData = await res.json();
        setError(errorData.error || 'Login failed');
        return;
      }
      
      const data = await res.json();
      onLogin(data);
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  const handleSignupClick = () => {
    // If no text entered, go to separate signup page
    if (!username.trim() && !password.trim()) {
      onGoToSignup();
      return;
    }
    
    // Otherwise, try to signup with current credentials
    authenticate('/api/signup');
  };

  const authenticate = async path => {
    setError('');
    
    if (!username.trim() || !password) {
      setError('Please enter both username and password');
      return;
    }

    try {
      const res = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
        credentials: 'include',
      });
      
      if (!res.ok) {
        const errorData = await res.json();
        setError(errorData.error || 'Authentication failed');
        return;
      }
      
      const data = await res.json();
      
      // Show welcome modal only for new signups
      if (path === '/api/signup') {
        setShowWelcomeModal(true);
        window.tempUserData = data;
      } else {
        onLogin(data);
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }
  };

  const handleWelcomeModalClose = () => {
    setShowWelcomeModal(false);
    // Complete the login process after modal closes
    if (window.tempUserData) {
      onLogin(window.tempUserData);
      delete window.tempUserData;
    }
  };

  return React.createElement('div', { className: 'page login-page' },
    React.createElement('div', { className: 'login-box' },
      React.createElement(PageHeader, {
        title: 'Welcome to Kinder!',
        description: 'Log in or sign up to start ranking names.'
      }),
      React.createElement('input', {
        placeholder: 'username',
        value: username,
        onChange: e => { setUsername(e.target.value); setError(''); }
      }),
      React.createElement('input', {
        type: 'password',
        placeholder: 'password',
        value: password,
        onChange: e => { setPassword(e.target.value); setError(''); }
      }),
      error && React.createElement('div', { className: 'error-message' }, error),
      React.createElement('div', { className: 'login-buttons' },
        React.createElement('button', { onClick: handleLogin }, 'Log In'),
        React.createElement('button', { onClick: handleSignupClick }, 'Sign Up')
      ),
      React.createElement('p', { className: 'auth-disclaimer' },
        'I created this login, auth and basically the entire site with ChatGPT. Think of it more as glorified profile creation, not actual security'
      )
    ),
    React.createElement(WelcomeModal, {
      isOpen: showWelcomeModal,
      onClose: handleWelcomeModalClose
    })
  );
}
